import {useMemo} from 'react';

import {oneOfType, node, func} from 'prop-types';

import SpreadsheetsContext from '../contexts/SpreadsheetsContext';
import {usePersistedReducer} from '../hooks/misc/usePersistedReducer';
import {ACTION_TYPES, initialState, reducer} from '../reducers/providers/spreadsheetsReducer';

// eslint-disable-next-line complexity
const SpreadsheetsProvider = ({children}) => {
  const spreadsheetsReducerKey = 'SPREADSHEETS_REDUCER_KEY';
  const {state, dispatch} = usePersistedReducer(reducer, initialState, spreadsheetsReducerKey);

  const setColumnWidth = (gridId, columnId, widthAfterResize) => {
    dispatch({
      type: ACTION_TYPES.SET_COLUMN_WIDTH,
      payload: {gridId, columnId, width: widthAfterResize}
    });
  };

  const setAllColumnsWidths = (gridId, columnsWidth) => {
    dispatch({
      type: ACTION_TYPES.SET_ALL_COLUMNS_WIDTHS,
      payload: {gridId, columnsWidth}
    });
  };

  const useMemoDeps = [state];
  const value = useMemo(
    () => ({
      allColumnsWidth: state,
      setColumnWidth,
      setAllColumnsWidths
    }),
    useMemoDeps
  );

  return <SpreadsheetsContext.Provider value={value}>{children}</SpreadsheetsContext.Provider>;
};

SpreadsheetsProvider.propTypes = {
  children: oneOfType([node, func]).isRequired
};

export default SpreadsheetsProvider;
